<template>
  <label for class="sb_label">
    <span class="sb_label_title" v-if="$slots.title">
      <slot name="title" />
    </span>
    <div class="sb_label_content" :class="{ v_line: line }" v-if="$slots.input">
      <slot name="input" />
    </div>
    <span class="sb_label_ext" v-if="$slots.ext">
      <slot name="ext" />
    </span>
  </label>
</template>

<script>
export default {
  name: 'Label',
  props: {
    line: {
      type: Boolean,
      default: true,
    },
    max: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_label {
    display: inline-block;
    position: relative;
    height: 100%;
    width: auto;
    margin-left: 0.6rem;
    z-index: 0;
    &:first-of-type {
      margin-left: 0;
    }
    &[disabled] {
      opacity: 0.6;
      pointer-events: none;
      select {
        background-image: none;
      }
    }
    &_content {
      width: 100%;
      height: 100%;
      position: relative;
      &.v_line {
        &:before {
          content: '';
          position: absolute;
          left: 0;
          z-index: 1;
          height: calc(100% - 6px);
          bottom: 3px;
          width: 3px;
          background: $brand-primary;
        }
      }
      & input,
      & textarea,
      & select {
        border-radius: $default-radius;
        border: 3px solid $brand-lightest-gray;
        display: flex;
        width: 100%;
        height: 100%;
        font-size: 1rem;
        letter-spacing: 0.25px;
        color: $brand-gray;
        padding: 0.8rem 1rem;
        transition: border 0.4s;
        &:focus {
          outline: none;
          border: 3px solid $brand-primary;
        }
        @include media('>=medium') {
          font-size: 1.1rem;
        }
      }
      & input {
        padding-right: 2rem;
      }
      & textarea {
        min-height: 5rem;
        max-height: 8rem;
      }
    }
    &_title {
      background: $brand-white;
      position: absolute;
      z-index: 1;
      font-size: 0.6rem;
      padding: 0 0.6rem 0 0.8rem;
      letter-spacing: 0.75px;
      transform: translateY(-50%);
      font-weight: 600;
      left: -3px;
      top: 0;
      @include media('>=medium') {
        font-size: 0.7rem;
      }
    }
    &_ext {
      position: absolute;
      right: 0.8rem;
      font-size: 0.7rem;
      font-weight: 700;
      top: calc(50% + 1px);
      transform: translateY(-50%);
      @include media('>=medium') {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
